import { ACTION_SET_USER_TYPE, IS_APPICANT_TYPE_OTHERS } from "../ActionTypes/MemberRegistrationActionTypes";

const initialState: any = {
  userTypeId: 0,
  isApplicantTypeOthers: false,
};
export const MemberRegistrationReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case ACTION_SET_USER_TYPE:
      return (state = { ...state, userTypeId: action.userTypeId });
    case IS_APPICANT_TYPE_OTHERS:
      return (state = {
        ...state,
        isApplicantTypeOthers: action.isApplicantTypeOthers,
      });

    default:
      return state;
  }
  return state;
};
